module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido19.3e94ea6e.svg";